module.exports = __webpack_public_path__ + "static/logitech-a9f6d1c21d0b5dc389a5bb89dfd7f599.jpg";